<template>
<v-card class="ma-0 pa-2">
    <div>
        <b>{{ item.name }} ({{ item.code }})</b>
        <v-icon class="mx-2" @click="$emit('find', item)">search</v-icon>
    </div>
    <v-row>
        <v-col class="py-1" cols="3">
            <span>·평가손익 </span>
            <span :style="{color: textColor(profit)}">{{ commaFormat(profit) }} 원</span>
        </v-col>
        <v-col class="py-1" cols="3">
            <span>·손익률 </span>
            <span :style="{color: textColor(profitRatio)}">{{ profitRatio.toFixed(2) }} %</span>
        </v-col>
        <v-col class="py-1" cols="3">·보유잔고 {{ commaFormat(item.count) }} 주</v-col>
        <v-col class="py-1" cols="3">·평균단가 {{ commaFormat(averagedPrice) }} 원</v-col>
        <v-col class="py-1" cols="3" >
            <span>·현재가 {{ commaFormat(item.price) }} 원</span>
            <v-icon class="mx-2" style="cursor: pointer" @click="$emit('price', item)">show_chart</v-icon>
        </v-col>
        <v-col class="py-1" cols="3">·매입금 {{ commaFormat(item.purchase) }} 원</v-col>
        <v-col class="py-1" cols="3">·평가금 {{ commaFormat(item.total) }} 원</v-col>
    </v-row>
    <v-row class="mx-2" justify="end" align="center">
        <v-btn rounded small @click="$emit('finance', item)">재무 정보</v-btn>
        <v-btn rounded small @click="$emit('disclosure', item)">공시 정보</v-btn>
        <v-btn rounded small @click="$emit('search', item)">뉴스 검색</v-btn>
        <v-spacer />
        <v-btn text color="red" @click="$emit('buy')">매 수</v-btn>
        <v-btn text color="blue" @click="$emit('sell')">매 도</v-btn>
    </v-row>
</v-card>
</template>

<script>
export default {
    name: 'stock-item',
    props: [
        'code', 'item'
    ],
    data() {
        return {}
    },
    computed: {
        profit() {
            return this.item.total - this.item.purchase
        },
        profitRatio() {
            return (this.item.total / this.item.purchase - 1) * 100 - 0.25
        },
        averagedPrice() {
            return Math.round(this.item.purchase / this.item.count)
        }
    },
    async mounted() {},
    methods: {
        textColor(value) {
            if (value > 0) return 'red'
            else if (value < 0) return 'blue'
            else return 'black'
        },
        commaFormat(value) {
            return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    }
}
</script>

<style>
.discuss-title:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>